export default "__VITE_ASSET__CED6IRYi__"